import styled from 'styled-components';
import Lab114 from 'dc/Lab114';
import Lab114B from 'dc/Lab114B';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const Participants = styled(Lab114)`
  flex-grow: 1;
  border-left: ${props =>
    props.theme === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.12)'
      : '1px solid rgba(38,50,56,0.12)'};
  border-right: ${props =>
    props.theme === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.12)'
      : '1px solid rgba(38,50,56,0.12)'};
`;

export const Savings = styled(Lab114B)`
  flex-grow: 1;
  cursor: pointer;
`;
